import { useEffect, useState } from 'react';
import { getCaseNode } from '@/api/nodes';
import { caseActions, useTempCustomProperty } from '@/stores/caseStore';
import { useCaseId, usePathwayCustomProperties } from '@/stores/pathwayStore';
import CustomPropertyDialog from './CustomPropertyDialog';
import { toast } from 'react-toastify';

const CustomPropertyContainer = () => {
  const tempCustomProperty = useTempCustomProperty();
  const caseId = useCaseId();
  const customProperties = usePathwayCustomProperties();
  const [caseNodeCustomProperties, setCaseNodeCustomProperties] = useState({});

  useEffect(() => {
    const loadCaseNode = async () => {
      if (!caseId || !tempCustomProperty?.id) {
        return;
      }

      try {
        const { data } = await getCaseNode(caseId, tempCustomProperty.id);
        setCaseNodeCustomProperties(data?.custom_properties ?? {});
      } catch {
        toast.error('Unable to load custom property values.');
        caseActions.clearTempCustomProperty();
      }
    };

    loadCaseNode();
  }, [caseId, tempCustomProperty]);

  if (!tempCustomProperty) {
    return null;
  }

  const clear = () => {
    caseActions.clearTempCustomProperty();
    setCaseNodeCustomProperties({});
  };

  return (
    <CustomPropertyDialog
      outputLabel={tempCustomProperty.label}
      outputName={tempCustomProperty.name}
      nodeId={tempCustomProperty.id}
      caseNodeCustomProperties={caseNodeCustomProperties}
      customProperties={customProperties}
      onClose={clear}
    />
  );
};

export default CustomPropertyContainer;
